import React, { useState } from 'react';
import API from "libs/api";
import { Modal, Button } from 'semantic-ui-react';
import ICON from "components/cmp_icon/cmp_icon";



export default function CMP_CONTACT_DELETE({ id, onOpen, onClose, onRefresh }) {

    //  variable declarations ------------------------------------------------------------------------------------------

    const [ var_processing, set_processing ] = useState('inactive');



    //  event listeners ------------------------------------------------------------------------------------------------



    //  async functions ------------------------------------------------------------------------------------------------

    async function delete_contact() {

        set_processing('processing');

        try {
            await API_delete_contact();
            set_processing('inactive');
            onRefresh();
            onClose();
        } catch (e) {
            set_processing('error');
            console.log(e);
        }
    }



    //  API calls ------------------------------------------------------------------------------------------------------

    function API_delete_contact(){
        return API.del('admin-providers', '/delete-provider-contact/' + id);
    }



    //  event functions ------------------------------------------------------------------------------------------------

    function onClick_delete(){
        delete_contact();
    }

    function onClick_cancel(){
        onClose();
    }



    // RENDER APP ======================================================================================================

    return (
        <Modal
            dimmer={'inverted'}
            onClose={onClose}
            open={onOpen}
            closeOnEscape={true}
            closeOnDimmerClick={true}
            id='cmp_contact_delete'>
            <div className='icon__wrapper'>
                <div className='icon'>
                    <ICON name='warning' className='icon' alt='contact icon'/>
                </div>
            </div>
            <div className="modal__header">
                <div className='text--md bold color--red-500' >Delete contact</div>
            </div>

            <div className='modal__content'>
                <div className='field__wrapper'>
                    <div className='text--base'>Are you sure you want to delete this contact?</div>
                </div>
            </div>

            <div className='modal__footer'>
                <Button className='primary' onClick={onClick_delete}>Delete</Button>
                <Button className='secondary' onClick={onClick_cancel}>Cancel</Button>
            </div>
        </Modal>
    );
}